import { Clock, Lock, XCircle, AlertTriangle, RefreshCw, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

const SUPPORT_EMAIL = 'suporte@joyn.com.br';

export const OrganizerPendingView = () => (
  <div className="flex flex-col items-center justify-center text-center p-8 max-w-md w-full mx-auto">
    <div className="relative w-20 h-20 mb-8">
      <div className="absolute inset-0 rounded-full border-4 border-border" />
      <div
        className="absolute inset-0 rounded-full border-4 border-transparent border-t-foreground animate-spin"
        style={{ animationDuration: '1.5s' }}
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <Clock className="w-8 h-8 text-muted-foreground" />
      </div>
    </div>
    <h2
      className="text-2xl font-bold tracking-tight mb-3"
      style={{ fontFamily: 'Manrope, sans-serif' }}
    >
      Sua solicitação está em análise
    </h2>
    <p className="text-muted-foreground leading-relaxed mb-2">
      Nossa equipe está revisando suas informações. Você receberá uma notificação
      assim que a análise for concluída.
    </p>
    <p className="text-sm text-muted-foreground mb-8">
      Esse processo pode levar até 48 horas úteis.
    </p>
    <Button variant="outline" onClick={() => window.location.reload()} className="gap-2">
      <RefreshCw className="w-4 h-4" />
      Atualizar status
    </Button>
  </div>
);

export const OrganizerRejectedView = () => (
  <div className="flex flex-col items-center justify-center text-center p-8 max-w-md w-full mx-auto">
    <div className="w-20 h-20 rounded-full bg-red-50 dark:bg-red-950/40 flex items-center justify-center mb-8">
      <XCircle className="w-10 h-10 text-red-500" />
    </div>
    <h2
      className="text-2xl font-bold tracking-tight mb-3"
      style={{ fontFamily: 'Manrope, sans-serif' }}
    >
      Solicitação não aprovada
    </h2>
    <p className="text-muted-foreground leading-relaxed mb-8">
      Sua solicitação de acesso como organizador não foi aprovada neste momento.
      Você pode entrar em contato com o suporte para obter mais informações ou
      aguardar para tentar novamente futuramente.
    </p>
    <div className="flex flex-col sm:flex-row gap-3 justify-center w-full sm:w-auto">
      <Button
        variant="outline"
        className="gap-2"
        onClick={() =>
          window.open(
            `mailto:${SUPPORT_EMAIL}?subject=Solicitação de organizador rejeitada`,
            '_blank'
          )
        }
      >
        <MessageCircle className="w-4 h-4" />
        Falar com suporte
      </Button>
      <Button
        variant="outline"
        onClick={() => window.location.reload()}
        className="gap-2"
      >
        <RefreshCw className="w-4 h-4" />
        Tentar novamente
      </Button>
    </div>
  </div>
);

export const OrganizerViewerView = () => (
  <div className="flex flex-col items-center justify-center text-center p-8 max-w-md w-full mx-auto">
    <div className="w-20 h-20 rounded-full bg-secondary flex items-center justify-center mb-8">
      <Lock className="w-10 h-10 text-muted-foreground" />
    </div>
    <h2
      className="text-2xl font-bold tracking-tight mb-3"
      style={{ fontFamily: 'Manrope, sans-serif' }}
    >
      Acesso exclusivo para organizadores
    </h2>
    <p className="text-muted-foreground leading-relaxed">
      Este painel é destinado exclusivamente a organizadores aprovados pela Joyn.
    </p>
  </div>
);

export const OrganizerErrorView = ({ onRetry }) => (
  <div className="flex flex-col items-center justify-center text-center p-8 max-w-md w-full mx-auto">
    <div className="w-20 h-20 rounded-full bg-secondary flex items-center justify-center mb-8">
      <AlertTriangle className="w-10 h-10 text-muted-foreground" />
    </div>
    <h2
      className="text-2xl font-bold tracking-tight mb-3"
      style={{ fontFamily: 'Manrope, sans-serif' }}
    >
      Não foi possível carregar o painel
    </h2>
    <p className="text-muted-foreground leading-relaxed mb-8">
      Ocorreu um problema ao carregar suas informações. Por favor, tente novamente.
    </p>
    <Button
      variant="outline"
      onClick={onRetry || (() => window.location.reload())}
      className="gap-2"
    >
      <RefreshCw className="w-4 h-4" />
      Tentar novamente
    </Button>
  </div>
);
